/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { mcpRegistriesListCatalog } from "../funcs/mcpRegistriesListCatalog.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListCatalogResponseBody } from "../models/components/listcatalogresponsebody.js";
import {
  ListMCPCatalogRequest,
  ListMCPCatalogSecurity,
} from "../models/operations/listmcpcatalog.js";
import { unwrapAsync } from "../types/fp.js";
export type ListMCPCatalogQueryData = ListCatalogResponseBody;

export function prefetchListMCPCatalog(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListMCPCatalogRequest | undefined,
  security?: ListMCPCatalogSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildListMCPCatalogQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildListMCPCatalogQuery(
  client$: GramCore,
  request?: ListMCPCatalogRequest | undefined,
  security?: ListMCPCatalogSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<ListMCPCatalogQueryData>;
} {
  return {
    queryKey: queryKeyListMCPCatalog({
      registryId: request?.registryId,
      search: request?.search,
      cursor: request?.cursor,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function listMCPCatalogQueryFn(
      ctx,
    ): Promise<ListMCPCatalogQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(mcpRegistriesListCatalog(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyListMCPCatalog(
  parameters: {
    registryId?: string | undefined;
    search?: string | undefined;
    cursor?: string | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "mcpRegistries", "listCatalog", parameters];
}
